// FOUC on-fully-loaded make the page visible:
addEventListener('load', (e) => {
	document.documentElement.style.visibility = 'visible';
});
